import { instance } from '../instance'

/**
 * Get available report formats for a wallet
 *
 * @param {string|number} walletId
 * @returns {Promise<import('axios').AxiosResponse<string[]>>}
 */
export const getFormats = (walletId) => {
  return instance.get(`/v2/wallet/${walletId}/report/list/format`)
}
